var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 0.666687C6.65341 0.666687 0.666748 6.65335 0.666748 14C0.666748 21.3467 6.65341 27.3334 14.0001 27.3334C21.3467 27.3334 27.3334 21.3467 27.3334 14C27.3334 6.65335 21.3467 0.666687 14.0001 0.666687ZM17.7201 14.7067L13.0134 19.4134C12.8134 19.6134 12.5601 19.7067 12.3067 19.7067C12.0534 19.7067 11.8001 19.6134 11.6001 19.4134C11.2134 19.0267 11.2134 18.3867 11.6001 18L15.6001 14L11.6001 10C11.2134 9.61335 11.2134 8.97335 11.6001 8.58669C11.9867 8.20002 12.6267 8.20002 13.0134 8.58669L17.7201 13.2934C18.1201 13.68 18.1201 14.32 17.7201 14.7067Z",
    fill: "#D4D4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideIcon2);
export default __webpack_public_path__ + "static/media/side-icon2.3965ae572c902ddd52a4bcca91686be9.svg";
export { ForwardRef as ReactComponent };